// @flow
import { styled } from 'mz-ui-kit'

// Container for the lightbox window
export const Container = styled('div', {
  position: 'fixed',
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  outline: 0,
})

// Gray overlay
export const Overlay = styled<{
  $showed?: boolean,
  $animated?: boolean,
}>('div', ({ $showed, $animated }) => ({
  position: 'fixed',
  width: '100%',
  height: '100%',
  opacity: $showed ? 1 : 0,
  transition: $animated
    ? 'all 550ms cubic-bezier(0.165, 0.84, 0.44, 1)'
    : 'none',
  backgroundColor: 'rgba(0,0,0,0.3)',
  zIndex: 0,
}))

// Mobile screen header with close button and title
export const Header = styled<{}>('div', ({ $palette }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  left: 0,
  zIndex: 2,
  height: '50px',
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 10px',
  borderBottom: `1px solid ${$palette('gray')}`,
  backgroundColor: `${$palette('white')}`,
}))

// Scrren title
export const TitleContainer = styled('div', {
  flexGrow: 1,
  minWidth: 0,
})

export const Title = styled('h1', {
  margin: 0,
  padding: 0,
  fontSize: '14px',
  fontWeight: 400,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: 'center',
})

export const Subtitle = styled('h2', {
  margin: 0,
  padding: 0,
  fontSize: '12px',
  fontWeight: 300,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: 'center',
})

// Wrapper which contains the window and title to
// animate appear of the screen
export const WindowWrapper = styled<{
  $showed?: boolean,
  $animated?: boolean,
}>('div', ({ $showed, $palette, $animated }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  backgroundColor: `${$palette('white')}`,
  transition: $animated
    ? 'all 650ms cubic-bezier(0.165, 0.84, 0.44, 1)'
    : 'none',
  transform: $showed ? 'translateY(0)' : 'translateY(100%)',
}))

// Lighbox window
export const Window = styled<{
  $haveHeader?: boolean,
}>('div', ({ $haveHeader }) => ({
  position: 'absolute',
  top: !$haveHeader ? 0 : '50px',
  bottom: 0,
  right: 0,
  left: 0,
  zIndex: 1,
  overflowX: 'hidden',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
}))

// Button to close the lightbox
export const CloseButton = styled<{
  $haveHeader?: boolean,
}>('div', ({ $palette, $haveHeader }) => ({
  position: 'absolute',
  fontSize: '14px',
  fontWeight: 300,
  padding: '13px 10px 12px 10px',
  backgroundColor: `${$palette('white').setAlpha($haveHeader ? 1 : 0)}`,
  right: 0,
  top: 0,
  zIndex: 2,
  lineHeight: '24px',
  color: `${$palette('text')}`,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '25%',
}))
